import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {NavigationUserComponent} from '../navigation-user/navigation-user.component';

export const authComponents = [
  LoginComponent,
  RegisterComponent
]
